import { render, staticRenderFns } from "./DocumentoExistente.vue?vue&type=template&id=40de2792&scoped=true"
import script from "./DocumentoExistente.vue?vue&type=script&lang=js"
export * from "./DocumentoExistente.vue?vue&type=script&lang=js"
import style0 from "./DocumentoExistente.vue?vue&type=style&index=0&id=40de2792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de2792",
  null
  
)

export default component.exports